import React, { useEffect, useState } from "react";
import Comments from "./Comments";
import PostData from "./PostData";
import NewComment from "./NewComment";
import "./Post.css";
import DeletePost from "./DeletePost";
import { useTranslation } from "react-i18next";

const Post = ({
  bulletinBoardIds,
  showCommentInPost,
  setShowCommentInPost,
}: {
  bulletinBoardIds: any[];
  showCommentInPost: boolean;
  setShowCommentInPost: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [superUserLogged, setSuperUserLogged] = useState(false);
  const { t } = useTranslation(["common"]);

  useEffect(() => {
    if (window.sessionStorage.getItem("superUser") === "true") {
      setSuperUserLogged(true);
    }
    if (superUserLogged) {
      window.sessionStorage.setItem("superUser", "true");
    }
  }, []);

  return (
    <div>
      {bulletinBoardIds
        .filter((post) => post._idPost != null && post.post != null)
        .sort(
          (a: any, b: any) =>
            new Date(b.post.dateTime).getTime() -
            new Date(a.post.dateTime).getTime()
        )
        .map((id) => (
          <div key={id._id} className="post-card">
            <PostData
              title={id.post.title}
              description={id.post.description}
              name={
                id.post.idCompany
                  ? id.post.idCompany.name
                  : t("common:deletedAccount")
              }
              image={
                id.post.idCompany ? id.post.idCompany.logo : undefined
              }
              dateTime={id.post.dateTime}
              file={id.post.images}
            />
            <Comments
              data={id}
              showCommentInPost={showCommentInPost}
              setShowCommentInPost={setShowCommentInPost}
              isSuperUser={superUserLogged}
            />
            {!superUserLogged ? (
              <NewComment
                idPost={id.post._id}
                showCommentInPost={showCommentInPost}
                setShowCommentInPost={setShowCommentInPost}
              />
            ) : (
              <></>
            )}
            {superUserLogged ||
            (id.post.idCompany !== null &&
              id.post.idCompany.id ===
                window.sessionStorage.getItem("company")) ? (
              <DeletePost
                idPost={id.post}
                selfRemove={
                  id.post.idCompany?.id ===
                  window.sessionStorage.getItem("company")
                }
              />
            ) : (
              <></>
            )}
          </div>
        ))}
    </div>
  );
};

export default Post;
